import React from 'react';

import { injectIntl, IntlShape } from 'react-intl';
import { StyledSmallSectionHeader } from 'containers/AUTODashboard/Body/MyContracts/styles';
import CustomCarousel from 'components/CustomCarousel';
import messages from 'containers/MRhDashboard/messages';
import { translate } from 'helpers/intl';
import { MRHInfoCard } from 'components/ItemInfoCard';
import { CONTRACT_STATUSES } from 'utils/globalConst';

const MyContracts = (props: { intl: IntlShape; contractsMRH: any }) => {
  return (
    <>
      <StyledSmallSectionHeader>
        {translate({ ...messages.title }, props)}
      </StyledSmallSectionHeader>
      <CustomCarousel showIndicators={props.contractsMRH.length > 1}>
        {props.contractsMRH.map(
          (
            contract: {
              status: string;
              adresse: string;
              deadline: string;
              contractNumber: string;
              product: string;
            },
            index: any,
          ) => (
            <MRHInfoCard
              key={index}
              status={
                contract.status === CONTRACT_STATUSES.ACTIVE
                  ? 'success'
                  : 'error'
              }
              statusLabel={
                contract.status === CONTRACT_STATUSES.ACTIVE
                  ? translate({ ...messages.Actif }, props)
                  : translate({ ...messages.Encours }, props)
              }
              title={contract.adresse}
              dateValue={contract.deadline}
              formuleValue={contract.product}
              contractsNumber={contract.contractNumber}
              wrapperPaddingRight={
                index === props.contractsMRH.length - 1 ? '24px' : '45px'
              }
              wrapperPaddingLeft={index === 0 ? '24px' : '45px'}
            />
          ),
        )}
      </CustomCarousel>
    </>
  );
};

export default injectIntl(MyContracts);
